import axios from 'axios';
import {AppDispatch} from "../store/store";
import {setSnackbarOpen} from "../store/slices/snackbar.slice";

interface HandleApiCallOptions<T> {
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: (response: T) => void;
    onError?: (error: any) => void;
    setLoading?: (loading: boolean) => void;
    logout?: () => void;
    dispatch?: AppDispatch;
}

export async function handleApiCall<T>(
    apiCall: () => Promise<T>,
    {
        successMessage,
        errorMessage,
        onSuccess,
        onError,
        setLoading,
        logout,
        dispatch,
    }: HandleApiCallOptions<T> = {}
): Promise<T | undefined> {
    try {
        setLoading?.(true);
        const response = await apiCall();

        if (successMessage && dispatch) {
            dispatch(setSnackbarOpen({
                snackbarMessage: successMessage,
                snackbarSeverity: 'success',
            }));
        }

        onSuccess?.(response);
        return response;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            if (logout) logout();
        } else {
            if (errorMessage && dispatch) {
                dispatch(setSnackbarOpen({
                    snackbarMessage: errorMessage,
                    snackbarSeverity: 'error',
                }));
            }
            onError?.(error);
        }
    } finally {
        setLoading?.(false);
    }
}
